/* eslint-disable @typescript-eslint/no-explicit-any */
// Shared function to load and store group data from cached group detail
// Returns the groupData if successfully loaded, null otherwise

import { STORAGE, STORAGE_KEY } from "@/constants";
import { getItem, setItem } from "./storage-utils";
import { validateGroupId } from "@/services/group";
import { getFlavourFor } from "@/config/product-config";

export const loadGroupDataFromCache = async () => {
  const existingGroupData = getItem(STORAGE_KEY.GROUP_DATA, STORAGE.SESSION);
  if (existingGroupData) {
    return existingGroupData; // Already loaded, return it
  }

  const cachedGroupDetail = getItem(
    STORAGE_KEY.CACHED_GROUP_DETAIL,
    STORAGE.LOCAL,
  );

  if (!cachedGroupDetail?.groupId) {
    return null;
  }

  try {
    const response = await validateGroupId(cachedGroupDetail.groupId);

    const groupData = {
      ...response?.data?.values,
      registrationFieldsLookup: response?.registrationFields,
    };

    if (groupData) {
      // Store groupData in sessionStorage
      setItem(STORAGE_KEY.GROUP_DATA, groupData, STORAGE.SESSION);

      // Also update productConfig for theming/branding
      const flavour = getFlavourFor(groupData.group_id, groupData?.division_id);
      if (flavour) {
        (window as any).__PRODUCT_CONFIG__ = flavour;
        setItem(STORAGE_KEY.PRODUCT_CONFIG, flavour, STORAGE.SESSION);
      }

      return groupData;
    }
  } catch (err) {
    console.error("Could not fetch group data", err);
  }

  return null;
};
